import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import InvoiceContainer from './Invoice';
import rootReducer from '../../reducers';
var store = createStore(rootReducer);
function Invoice(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(InvoiceContainer, props));
}
export default Invoice;